import React from "react";

/**
 * DeleteBtn - Faded-border trash icon button with red hover effect.
 * Matches the close button style used in Question.jsx modal header.
 *
 * Usage:
 *   <DeleteBtn onClick={() => removeRow(i)} title="Remove Row" size={38} />
 */
const DeleteBtn = ({ onClick, title = "Remove", size = 32 }) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    style={{
      background: "none",
      border: "1.5px solid #e2e8f0",
      borderRadius: "8px",
      width: size,
      height: size,
      flexShrink: 0,
      padding: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      color: "#64748b",
      transition: "all 0.18s",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "#fff5f2";
      e.currentTarget.style.borderColor = "#e05c3a";
      e.currentTarget.style.color = "#e05c3a";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "none";
      e.currentTarget.style.borderColor = "#e2e8f0";
      e.currentTarget.style.color = "#64748b";
    }}
  >
    <i className="fas fa-trash-alt" style={{ fontSize: 12 }}></i>
  </button>
);

export default DeleteBtn;
